import type { MappedIconMicro } from "@/icons/icon-mapping-micro";
import type { PreviewContext } from "@/store/stores/ui-states";

type ContextConfiguration = {
  icon: MappedIconMicro;
  title: string;
};

export const CONTEXT_TO_CONFIGURATION: Record<
  PreviewContext,
  ContextConfiguration
> = {
  email: {
    icon: "envelope",
    title: "Email",
  },
  web: {
    icon: "globe-alt",
    title: "Web",
  },
  portal: {
    icon: "stack",
    title: "Portal",
  },
  subscribe: {
    icon: "user-plus",
    title: "Subscribe",
  },
  archive: {
    icon: "archive-box",
    title: "Archive",
  },
};
